import React, { useEffect, useState, useCallback } from "react";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import Svg from "../../../component/Svg";
import Input from "../../../core/Inputs/DefaultInput";
import { Formik } from "formik";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import { toast } from "react-toastify";
import { setPlatformAPI, use } from "echarts";
import { getTokenData } from '../../../store/actions/authAction'

export default function RoiCustomVariableAdd() {
    const apiUrl = process.env.REACT_APP_NODE_API_URL;
    const { id, cid } = useParams();
    const navigate = useNavigate()
    const [variableName, setVariableName] = useState('');
    const [variableValue, setVariableValue] = useState('');
    const [variableType, setVariableType] = useState('');

    const [roiActionArr, setRoiActionArr] = useState([]);
    const [userId, setuserId] = useState('');

    // Get the state props
    const location = useLocation();
    const breadcrumbs = location.state || {};

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getTokenData(setuserId))
    }, [userId, dispatch])
    
    const getRoiCustomVariableDetail = async () => {
        try {
            // console.log(`${apiUrl}/roi-calculated-fields/detail/${cid}`)
            const response = await performHttpRequest(
                "GET",
                `${apiUrl}/roi-custom-variables/detail/${cid}`,
                ""
            );
            if (response.data?.statusCode === 200 && response.data?.result == 'success') {
                // console.log("cid data ", response.data?.data[0])
                setVariableName(response.data?.data[0].roi_custom_variable_name);
                setVariableValue(response.data?.data[0].roi_custom_variable_value);
                setVariableType(response.data?.data[0].roi_custom_variable_type);
            }
        } catch (error) {
            toast.error(error?.response?.data?.responseText);
        }
    };

    const onChangeVariableName = async (e) => {
        setVariableName(e.target.value)
    }

    const onChangeVariableValue = async (e) => {
        setVariableValue(e.target.value)
    }

    const onChangeVariableType = async (e) => {
        setVariableType(e.value)
    }

    function toCamelCase(str) {
        return (str.charAt(0).toUpperCase()) + str.slice(1).toLowerCase();
    }
    //-----------------Sybmit-----------------------------
    const handleSubmit = async () => {

        if (cid == undefined || cid == '' || cid == null) {
            let post_arr = {
                "roi_custom_variable_name": variableName,
                "roi_custom_variable_value": variableValue,
                "roi_custom_variable_type": variableType,
                "roi_id": id,
                "is_active": "1",
                "added_by": userId
            }
            const response = await performHttpRequest(
                "POST",
                `${apiUrl}/roi-custom-variables/add`,
                post_arr
            );

            if (response.data.result == 'success') {
                toast.success("Added Successfully");
                navigate(`/admin/roi/${id}/custom-variable`);
            }
        } else {
            let update_arr = {
                "roi_custom_variable_name": variableName,
                "roi_custom_variable_value": variableValue,
                "roi_custom_variable_type": variableType,
                "roi_custom_variable_id": cid
            }
            const response = await performHttpRequest(
                "POST",
                `${apiUrl}/roi-custom-variables/update`,
                update_arr
            );

            if (response.data.result == 'success') {
                toast.success("Updated Successfully");
            }
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            if (cid === undefined || cid === '' || cid === null) {

            } else {
                await getRoiCustomVariableDetail();
            }
        };

        fetchData();
    }, [cid]);


    return (
        <>
            <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">
                        <div className="flex-grow-1 variable-pg-content">
                            {/* breadcrumbs here */}
                            <div className="custom-breadcrumb">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/admin/dashboard" className="home-item" title="Dashboard">Home</Link></li>
                                        {/* <li className="breadcrumb-item" >ROI Calculator</li>
                                        <li className="breadcrumb-item" >Calculator Name</li> */}
                                        {Object.keys(breadcrumbs).map((key) => (
                                            <li className="breadcrumb-item" key={key}><Link to={`${breadcrumbs[key]}`} >{key}</Link></li>
                                        ))}
                                        
                                        {/* <li className="breadcrumb-item" key={""}><Link to={`${(Object.keys(breadcrumbs)[0])}`} >{Object.keys(breadcrumbs)[0]}</Link></li>
                                        <li className="breadcrumb-item" key={"key"}><Link to={`${Object.keys(breadcrumbs)[1]}`} >{Object.keys(breadcrumbs)[1]}</Link></li> */}
                                        {/* <li className="breadcrumb-item active" aria-current="page"><strong>Calculations Add</strong></li> */}
                                    </ol>
                                </nav>
                            </div>
                            {/* breadcrumbs ends here */}
                            <div className="survey-main-container">

                                <div className="pagesRow varPg">
                                    <div className="role-wrapper flex-grow-1">

                                        <div className="create-team-form">
                                            <div className="row gx-12px">
                                                <div className="col-lg-12 position-relative">
                                                    <div className="form-group mb-12px">
                                                        <label><strong>Variable Name</strong></label>
                                                        <Input
                                                            type="text"
                                                            view="outlined"
                                                            dense={false}
                                                            name="variable_name"
                                                            color="default"
                                                            label=""
                                                            placeholder="Variable name"
                                                            clearButton={true}
                                                            success={false}
                                                            error={false}
                                                            fill={true}
                                                            errorHelperText={null}
                                                            className={"formsinput"}
                                                            onChange={onChangeVariableName}
                                                            maxLength={100}
                                                            value={variableName}
                                                        />
                                                    </div>
                                                    {/* {errors.team_name && (
                                                        <div className="validation-msg">
                                                            {errors.team_name}
                                                        </div>
                                                    )} */}
                                                </div>

                                                <div className="col-lg-12 position-relative">
                                                    <div className="form-group mb-12px">
                                                        <label><strong>Variable Value</strong></label>
                                                        <Input
                                                            type="text"
                                                            view="outlined"
                                                            dense={false}
                                                            name="variable_value"
                                                            color="default"
                                                            label=""
                                                            placeholder="Variable value"
                                                            clearButton={true}
                                                            success={false}
                                                            error={false}
                                                            fill={true}
                                                            errorHelperText={null}
                                                            className={"formsinput"}
                                                            onChange={onChangeVariableValue}
                                                            maxLength={100}
                                                            value={variableValue}
                                                        />
                                                    </div>
                                                    {/* {errors.team_name && (
                                                        <div className="validation-msg">
                                                            {errors.team_name}
                                                        </div>
                                                    )} */}
                                                </div>

                                                <div className="col-lg-12 position-relative">
                                                    <div className="form-group mb-12px">
                                                        <label><strong>Variable Type</strong></label>
                                                        <Select
                                                            className="custom-select"
                                                            classNamePrefix="select"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            name="conditions"
                                                            options={[
                                                                { value: 'number', label: 'Number' },
                                                                { value: 'currency', label: 'Currency' },
                                                                { value: 'text', label: 'Text' },
                                                            ]}
                                                            value={{ value: variableType, label: toCamelCase(variableType) }}
                                                            onChange={onChangeVariableType}
                                                        />
                                                    </div>
                                                    {/* {errors.team_name && (
                                                        <div className="validation-msg">
                                                            {errors.team_name}
                                                        </div>
                                                    )} */}
                                                </div>
                                            </div>

                                            <div className="button-wrap">
                                                <button type="button " className="btn btn-primary" onClick={handleSubmit}>
                                                    Save
                                                </button>
                                                {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                                                {/* <button type="button" className="btn btn-primary">Save</button> */}

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
